<template>
  <hm-content title="">
    <div class="flex flex-wrap item-center">
      <el-radio-group
        v-model="searchCondition.getcashType"
        size="small"
        class="mr20"
        @change="switchTabs"
      >
        <el-radio-button label="weChat">微信提现</el-radio-button>
        <el-radio-button label="aliPay">支付宝提现</el-radio-button>
      </el-radio-group>
      <div v-if="searchCondition.getcashType === 'weChat'">
        提现发放模式：
        <el-radio-group v-model="sendWay" size="small" @change="stateChange">
          <el-radio label="redMoney">公众号红包</el-radio>
          <el-radio label="coin">发放到零钱</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="mt20 flex flex-between">
      <el-radio-group
        v-model="searchCondition.auditState"
        size="small"
        @change="switchTabs"
      >
        <el-radio-button label="wait">待审核</el-radio-button>
        <el-radio-button label="agree">同意</el-radio-button>
        <el-radio-button label="refuse">驳回</el-radio-button>
        <el-radio-button label="">全部</el-radio-button>
      </el-radio-group>
      <div>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="申请开始日期"
          end-placeholder="申请结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-input
          clearable
          v-model.trim="searchCondition.keyWord"
          placeholder="输入提现单号/会员姓名/电话号码"
          size="small"
          style="width: 222px"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="outputAll"
          :loading="isOutputing"
          >导出</el-button
        >
        <el-button
          v-if="searchCondition.getcashType === 'aliPay'"
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出模板</el-button
        >
      </div>
    </div>
    <div class="table mt10" v-show="searchCondition.getcashType === 'weChat'">
      <el-table
        stripe
        border
        ref="weChattable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="selection"
          v-if="searchCondition.getcashType === 'aliPay'"
        ></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              class="status success"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'agree'"
              >通过</span
            >
            <span
              class="status blue"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'wait'"
              >待审核</span
            >
            <span
              class="status danger"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'refuse'"
              >驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashSn"
          label="提现单号"
        >
          <template slot-scope="scope">
            {{ scope.row.getcashSn }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        >
          <template slot-scope="scope">
            {{ scope.row.memberName }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="109"
          v-if="searchCondition.getcashType === 'aliPay'"
          header-align="center"
          align="center"
          prop="alipayAccount"
          label="支付宝收款账号"
        >
          <template slot-scope="scope">
            {{ scope.row.alipayAccount }}
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPhone"
          label="电话号码"
        >
          <template slot-scope="scope">
            {{ scope.row.memberPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idcard"
          label="身份证号"
        >
          <template slot-scope="scope">
            {{ scope.row.idcard }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcachApplyTime"
          label="申请时间"
        >
          <template slot-scope="scope">
            {{ scope.row.getcachApplyTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashMoney"
          label="申请金额"
        >
          <template slot-scope="scope">
            <div class="primary" v-if="scope.row.getcashMoney">
              ¥{{ scope.row.getcashMoney }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
          <template slot-scope="scope">
            {{ scope.row.auditTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        >
          <template slot-scope="scope">
            {{ scope.row.auditUsername }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="refuseReason"
          label="驳回备注"
          width="200"
          :show-overflow-tooltip="true"
        >
          <!-- <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.refuseReason"
                    placement="top"
                  >
                  <div>
                     {{ scope.row.refuseReason }}
                  </div>

                  </el-tooltip>
                </template> -->
        </el-table-column>
        <!-- 已审核已驳回不显示 -->
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="bill(scope.row)"
                >个人账单</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="audit(scope.row, 'pass')"
                v-if="scope.row.auditState === 'wait'"
                >通过</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.auditState === 'wait'"
                @click="audit(scope.row, 'reject')"
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </div>
    <div class="table mt10" v-show="searchCondition.getcashType === 'aliPay'">
      <el-table
        stripe
        border
        ref="aliPaytable"
        :data="list"
        @selection-change="getChecked"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              class="status success"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'agree'"
              >通过</span
            >
            <span
              class="status blue"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'wait'"
              >待审核</span
            >
            <span
              class="status danger"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'refuse'"
              >驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashSn"
          label="提现单号"
        >
          <template slot-scope="scope">
            {{ scope.row.getcashSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        >
          <template slot-scope="scope">
            {{ scope.row.memberName }}
          </template>
        </el-table-column>
        <el-table-column
          width="109"
          v-if="searchCondition.getcashType === 'aliPay'"
          header-align="center"
          align="center"
          prop="alipayAccount"
          label="支付宝收款账号"
        >
          <template slot-scope="scope">
            {{ scope.row.alipayAccount }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPhone"
          label="电话号码"
        >
          <template slot-scope="scope">
            {{ scope.row.memberPhone }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idcard"
          label="身份证号"
        >
          <template slot-scope="scope">
            {{ scope.row.idcard }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcachApplyTime"
          label="申请时间"
        >
          <template slot-scope="scope">
            {{ scope.row.getcachApplyTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashMoney"
          label="申请金额"
        >
          <template slot-scope="scope">
            <div class="primary" v-if="scope.row.getcashMoney">
              ¥{{ scope.row.getcashMoney }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnReceiptSn"
          label="转账流水号"
        >
          <template slot-scope="scope">
            {{ scope.row.returnReceiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
          <template slot-scope="scope">
            {{ scope.row.auditTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        >
          <template slot-scope="scope">
            {{ scope.row.auditUsername }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="refuseReason"
          label="驳回备注"
          width="200"
          :show-overflow-tooltip="true"
        >
          <!-- <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.refuseReason"
                    placement="top"
                  >
                  <div>
                     {{ scope.row.refuseReason }}
                  </div>

                  </el-tooltip>
                </template> -->
        </el-table-column>
        <!-- 已审核已驳回不显示 -->
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="bill(scope.row)"
                >个人账单</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="audit(scope.row, 'pass')"
                v-if="scope.row.auditState === 'wait'"
                >通过</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.auditState === 'wait'"
                @click="audit(scope.row, 'reject')"
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      width="600px"
      :title="flag === 'jujue' ? '驳回' : '同意'"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item
          label="驳回原因"
          prop="refuseReason"
          v-if="flag === 'jujue'"
        >
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因，可直接选择下方模板"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.refuseReason"
          ></el-input>
          <div class="reject-reason" v-if="flag === 'jujue'">
            <el-radio-group v-model="rejectReason" @change="switchRejectReason">
              <div v-for="(v, i) in rejectTemp" :key="i">
                <el-radio :label="i">{{ v }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item
          label="流水单号"
          prop="returnReceiptSn"
          v-if="flag === 'liushui'"
        >
          <el-input
            size="small"
            clearable
            style="width:300px"
            class="mr10 ipt"
            v-model.trim="ruleForm.returnReceiptSn"
            placeholder="请填写转账流水单号"
          ></el-input>
          <div class="form-tip" v-if="flag === 'liushui'">
            该单号本系统制作存储，方便财务后期核对账务使用
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="innerVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :before-close="cancel"
      width="1200px"
    >
      <div v-if="type === 'tishi'">
        <div class="flex flex-center">
          <span
            class="hmicon icon-tishi"
            style="fontSize:50px;color:rgb(243, 174, 64)"
          ></span>
        </div>
        <div class="mt10" style="color:#222;fontSize:16px">
          <div class="flex flex-center">
            切换提现模式不会改变已申请的提醒申报单的发放方式，后续申报当将
          </div>
          <div class="flex flex-center">
            已修改后的发放模式发放，请确认是否修改。
          </div>
        </div>
      </div>
      <div v-if="type === 'bill'">
        <el-radio-group v-model="billType" size="small" @change="switchTab">
          <el-radio-button label="daoGou">导购账单</el-radio-button>
          <el-radio-button label="fenXiao">分销账单</el-radio-button>
          <el-radio-button label="withdraw">提现账单</el-radio-button>
        </el-radio-group>
        <div class="modal-table mb20 mt10">
          <el-table stripe :data="[currentRow]" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberPhone"
              label="电话"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="idcard"
              label="身份证号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="所属商户"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopName"
              label="所属门店"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="allowGetcashMoneyAmount"
              label="可提现"
            >
              <template slot-scope="scope">
                {{ scope.row.allowGetcashMoneyAmount }}元
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="beingGetcashMoneyAmount"
              label="待发放"
            >
              <template slot-scope="scope">
                {{ scope.row.beingGetcashMoneyAmount }}元
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="hasGetcashMoneyAmount"
              label="已提现"
            >
              <template slot-scope="scope">
                {{ scope.row.hasGetcashMoneyAmount }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="billType === 'withdraw'">
          <div class="table-panel ">
            <div class="text-right">
              <el-input
                clearable
                style="width: 200px"
                v-model.trim="withdrawConditions.getcashSn"
                placeholder="请输入提现单号"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-date-picker
                v-model="withdrawConditions.getcachApplyTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择申请时间段"
                end-placeholder="选择申请时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-date-picker
                v-model="withdrawConditions.auditTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择审核时间段"
                end-placeholder="选择审核时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>

              <el-button
                type="primary"
                size="small"
                @click="queryWithDrawOrderList(currentRow)"
                >查询</el-button
              >
              <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllWithDrawOrderList', '提现账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
            </div>
          </div>
          <div class="table">
            <el-table stripe border :data="widthDrawList" size="small">
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (withdrawCurrentPage - 1) * withdrawPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.getcashSn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcachApplyTime"
                label="申请时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.getcachApplyTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.auditTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.auditUsername }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="提现金额"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.getcashMoney }}</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="widthDrawListTotal"
                @current-change="withDrawpaging"
                @size-change="handleWithDrawSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="withdrawCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div v-if="billType === 'daoGou'">
          <div class="table-panel flex flex-end" v-if="currentRow.guiderId">
            <div class="flex-1 text-right">
              <el-date-picker
                v-model="declareTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择上传时间段"
                end-placeholder="选择上传时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-button
                type="primary"
                size="small"
                @click="queryGuiderOrderList(currentRow)"
                >查询</el-button
              >
            </div>
          </div>
          <div class="table" v-if="currentRow.guiderId">
            <el-table stripe border :data="guiderList" size="small">
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index => index + (guiderCurrentPage - 1) * guiderPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareSn"
                label="申报单号"
              >
                <template slot-scope="scope">
                  <div
                    class="blue pointer"
                    @click="viewDetails(scope.row.declareSn)"
                  >
                    {{ scope.row.declareSn }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="小票号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptSn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="申报时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.declareTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptTime"
                label="小票日期"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptDate }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="销售商品数量"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.goodsNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="总计收益"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="flex flex-end" style="fontSize:15px">
              当前页面的总计收益:
              <span class="primary"> {{ currentTotal }}</span
              >元
            </div>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="guiderTotal"
                @current-change="guiderPaging"
                @size-change="handleGuiderSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="guiderCurrentPage"
              ></el-pagination>
            </div>
          </div>
          <div v-else class="mt10 danger">
            还不是导购!
          </div>
        </div>
        <div v-if="billType === 'fenXiao'">
          <div class="table-panel flex flex-end">
            <div class="flex-1 text-right">
              <el-date-picker
                v-model="unlockTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择解锁时间段"
                end-placeholder="选择解锁时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-button
                type="primary"
                size="small"
                @click="queryShareOrderList(currentRow)"
                >查询</el-button
              >
              <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllShareOrderList', '分销账单')"
              :loading="isOutputing"
              >导出账单</el-button
            > -->
            </div>
          </div>
          <div class="table">
            <el-table stripe border :data="shareList" size="small">
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (shareOrderPageNo - 1) * shareOrderPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptSn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payTime"
                label="付款日期"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.payTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="unlockTime"
                label="解锁日期"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.unlockTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="订单金额"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalGoodsNum"
                label="订单商品数量"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.totalGoodsNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="所属商城"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.storeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="总计收益"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.commissionPrice }}</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="shareListTotal"
                @current-change="shareListPaging"
                @size-change="handleShareListSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="shareOrderPageNo"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="confirm" size="small" type="primary"
          >确 定</el-button
        >
        <el-button @click="cancel" type="info" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      flag: "",
      ruleForm: {
        refuseReason: "",
        returnReceiptSn: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        },
        returnReceiptSn: {
          required: true,
          message: "请填写转账流水单号",
          trigger: "blur"
        }
      },
      type: "",
      billType: "daoGou",
      innerVisible: false,
      dialogVisible: false,
      title: "",
      sendWay: "coin",
      searchCondition: {
        getcashType: "weChat",
        auditState: "wait"
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      guiderCurrentPage: 1,
      guiderPageSize: 10,
      guiderTotal: 0,
      currentTotal: 0,
      guiderList: [],
      currentRow: {},
      declareTime: [],
      rejectTemp: [],
      rejectReason: "",
      isOutputing: false,
      widthDrawList: [],
      widthDrawListTotal: 0,
      withdrawPageSize: 10,
      withdrawCurrentPage: 1,
      shareList: [],
      shareListTotal: 0,
      shareOrderPageSize: 10,
      shareOrderPageNo: 1,
      unlockTime: [],
      withdrawConditions: {},
      checkedRow: [],
      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryDict();
  },
  methods: {
    viewDetails(declareSn) {
      let routeData = this.$router.resolve({
        name: "DetailsSalesVolumeNew",
        query: { declareSn }
      });
      window.open(routeData.href, "_blank");
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    withDrawpaging(page) {
      this.withdrawCurrentPage = page;
      this.queryWithDrawOrderList();
    },
    handleWithDrawSizeChange(size) {
      this.withdrawCurrentPage = 1;
      this.withdrawPageSize = size;
      this.queryShareOrderList();
    },
    shareListPaging(page) {
      this.shareOrderPageNo = page;
      this.queryShareOrderList();
    },
    handleShareListSizeChange(size) {
      this.shareOrderPageNo = 1;
      this.shareOrderPageSize = size;
      this.queryShareOrderList();
    },
    switchTab(val) {
      if (val === "daoGou") {
        this.queryGuiderOrderList();
      } else if (val === "fenXiao") {
        this.queryShareOrderList();
      } else if (val === "withdraw") {
        this.queryWithDrawOrderList();
      }
    },
    async queryWithDrawOrderList() {
      let params = {
        customerId: this.currentRow.customerId,
        pageNo: this.withdrawCurrentPage,
        pageSize: this.withdrawPageSize
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      // withdrawConditions
      const { result } = await this.$store.dispatch(
        "queryWithDrawOrderList",
        params
      );
      const { records, total } = result;
      this.widthDrawList = records;
      this.widthDrawListTotal = total;
    },
    async queryShareOrderList() {
      const { result } = await this.$store.dispatch("queryShareOrderList", {
        customerId: this.currentRow.customerId,
        pageSize: this.shareOrderPageSize,
        pageNo: this.shareOrderPageNo,
        unlockStartTime: this.unlockTime ? this.unlockTime[0] : "",
        unlockEndTime: this.unlockTime ? this.unlockTime[1] : ""
      });
      const { records, total } = result;
      this.shareList = records;
      this.shareListTotal = total;
    },
    async operation(params) {
      params.sendWay = this.sendWay;
      const { code } = await this.$store.dispatch("opertaeCashOutList", params);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.queryList();
        this.resetRuleForm();
      }
    },
    submitReject(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          const params = JSON.parse(JSON.stringify(this.row));
          Object.assign(params, ruleForm);
          if (this.flag === "jujue") {
            params.auditState = "refuse";
            this.operation(params);
          } else if (this.flag === "liushui") {
            params.auditState = "agree";
            this.operation(params);
          }
        } else {
          return false;
        }
      });
    },
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: "getcash_audit_manual_template"
      });
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },
    async audit(row, audit) {
      this.flag = audit === "pass" ? "liushui" : "jujue";
      this.row = row;
      if (this.searchCondition.getcashType === "weChat") {
        if (audit === "reject") {
          this.innerVisible = true;
        } else {
          this.$confirm(
            `是否${audit === "pass" ? "通过" : "驳回"}申请？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(() => {
              const searchCondition = JSON.parse(JSON.stringify(row));
              searchCondition.auditState = "agree";
              this.operation(searchCondition);
              // if (audit === "reject") {
              //   this.innerVisible = true;
              // } else {
              //   const searchCondition = JSON.parse(JSON.stringify(row));
              //   searchCondition.auditState = "agree";
              //   this.operation(searchCondition);
              // }
            })
            .catch(() => {});
        }
      } else {
        this.innerVisible = true;
      }
    },
    bill(row) {
      this.type = "bill";
      this.title = "个人账单";
      this.dialogVisible = true;
      this.currentRow = row;
      if (this.billType === "daoGou") {
        this.queryGuiderOrderList();
      } else if (this.billType === "fenXiao") {
        this.queryShareOrderList();
      } else if (this.billType === "withdraw") {
        this.queryWithDrawOrderList();
      }
    },
    async queryGuiderOrderList() {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: this.currentRow.guiderId,
        auditState: "agree",
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length ? this.declareTime[1] : ""
      });
      const { records, total } = result;
      this.guiderList = records;
      let currentTotal = 0;
      this.guiderList.forEach(v => {
        currentTotal += v.redpackageMoney;
      });
      this.currentTotal = currentTotal.toFixed(2);
      this.guiderTotal = total;
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList();
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList();
    },
    confirm() {
      if (this.type === "bill") {
        this.dialogVisible = false;
      } else if (this.type === "tishi") {
        this.dialogVisible = false;
      }
    },
    cancel() {
      if (this.type === "tishi") {
        this.sendWay = this.sendWay === "redMoney" ? "coin" : "redMoney";
      }
      this.dialogVisible = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    stateChange() {
      this.dialogVisible = true;
      this.title = "提示";
      this.type = "tishi";
    },
    cashTypeTab() {
      this.currentPage = 1;
      this.queryList();
    },
    switchTabs() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryCashOutList", params);
      this.list = result.records;
      this.total = result.total;
    },
    queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCashOutList", params);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.ruleForm.auditState = "";
        this.rejectReason = "";
        this.innerVisible = false;
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    // 导出excel
    output() {
      if (this.checkedRow.length > 0) {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          this.isOutputing = true;

          // this.queryAllList()
          //   .then(res => {
          let list = this.checkedRow;

          list.forEach((v, i) => {
            v.index = i + 1;
          });
          let tHeader = [
            "序号",
            "收款方支付宝账号",
            "收款方姓名",
            "金额(元)",
            "备注"
          ];

          let filterVal = [
            "index",
            "alipayAccount",
            "memberName",
            "getcashMoney",
            "xxxx"
          ];

          let title = "支付宝批量付款模板";

          let data = this.formatJson(filterVal, list);

          exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
          this.isOutputing = false;
          // })
          // .catch(() => {
          //   this.isOutputing = false;
          // });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请选择要导出的模板！"
        });
      }
    },
    outputAll() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              if (v.auditState === "agree") {
                v.auditState = "通过";
              } else if (v.auditState === "wait") {
                v.auditState = "待审核";
              } else if (v.auditState === "refuse") {
                v.auditState = "驳回";
              }
            });

            const tHeader =
              this.searchCondition.getcashType === "weChat"
                ? this.$refs.weChattable.columns
                    .map(
                      o => o.label !== "序号" && o.label !== "操作" && o.label
                    )
                    .filter(o => o)
                : this.$refs.aliPaytable.columns
                    .map(
                      o => o.label !== "序号" && o.label !== "操作" && o.label
                    )
                    .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal =
                this.searchCondition.getcashType === "weChat"
                  ? this.$refs.weChattable.$children
                      .map(o => o._props.prop)
                      .filter(o => o)
                  : this.$refs.aliPaytable.$children
                      .map(o => o._props.prop)
                      .filter(o => o);
            }

            let title =
              this.searchCondition.getcashType === "weChat"
                ? "微信提现申报列表"
                : "支付宝提现申报列表";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });

        // })
        // .catch(() => {
        //   this.isOutputing = false;
        // });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss">
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.modal-table {
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
}
</style>
